import { FetchApiResponse } from "redux/types";

export enum OverdueReportReduxTypes {
    OVERDUE_REPORT = "@@auth/OVERDUE_REPORT",
    OVERDUE_REPORT_SUCCESS = "@@auth/OVERDUE_REPORT_SUCCESS",
    OVERDUE_REPORT_ERROR = "@@auth/OVERDUE_REPORT_ERROR"
}

export type OverdueReportActionDispatch = {
    type: | OverdueReportReduxTypes.OVERDUE_REPORT;
    payload: any;
}

export type OverdueReportReducerDispatch = {
    type: | OverdueReportReduxTypes.OVERDUE_REPORT
    | OverdueReportReduxTypes.OVERDUE_REPORT_SUCCESS
    | OverdueReportReduxTypes.OVERDUE_REPORT_ERROR

    payload: {
        data?: FetchApiResponse<OverdueReport>
        error?: string
    }
}

export type OverdueReport = {
    id: string,
    financierId: string,
    userId: string,
    type: string,
    status: number,
    updatedOn: string;
    createdOn: string;
}

export type CreateOverdueReportRequest = {
    payload: {},
    type: string
}

export type CreateOverdueReportReduxState = {
    loading?: boolean
    data?: {},
    error?: string | null;
}